import React from 'react';

import { CustomerGroup } from '../../../home/types/home.types';
import { CartGroupView, CartMetadataItem, AddOnConfigData, AvailableAddOnsShape } from '../../types/cartTypes';

import CartItemRow from './cartItemRow';
import CartLoginPrompt from './cartLoginPrompt';



interface CartItemsListProps {
  groupedItems: CartGroupView[];
  productMetadata: Record<string, CartMetadataItem>;
  availableAddOns: AvailableAddOnsShape;
  customerGroups: CustomerGroup[];
  config: { locale: string };
  currency: string;
  onIncrement: (group: CartGroupView) => void;
  onDecrement: (group: CartGroupView) => void;
  onConfigureAddOns: (group: CartGroupView, data: AddOnConfigData) => Promise<void>;
  locale: string;
  isLoggedIn: boolean;
  onLogin: () => void;
}

const CartItemsList: React.FC<CartItemsListProps> = ({
  groupedItems,
  productMetadata,
  availableAddOns,
  customerGroups,
  config,
  currency,
  onIncrement,
  onDecrement,
  onConfigureAddOns,
  locale,
  isLoggedIn,
  onLogin,
}) => {
  return (
    <div className="flex flex-col gap-4 bg-transparent p-0 border-none">
      <div className="flex flex-col gap-[2.25rem]">
        {groupedItems.map((group) => (
        <CartItemRow
            key={group.key ?? group.mainItem?.id}
            group={group}
            productMetadata={productMetadata}
            availableAddOns={availableAddOns}
            customerGroups={customerGroups}
            config={config}
            currency={currency}
            onIncrement={onIncrement}
            onDecrement={onDecrement}
            onConfigureAddOns={onConfigureAddOns}
            locale={locale}
          />
        ))}
      </div>

      {!isLoggedIn && <CartLoginPrompt onLogin={onLogin} />}
    </div>
  );
};

export default CartItemsList;
